import { isValidEmail, isValidUSOrCanadianPhoneNumber, isValidMexicanPhoneNumber, isValidName } from '@usas/ui-web/utils/validation';

const PreCompLocationFacilityContactFormValidation = (formState) => {
  let errors = {};

  if (formState.contactName.trim() === '') {
    errors.contactName = 'Facility Primary Contact Name is required'
  } else if (!isValidName(formState.contactName.trim())) {
    errors.contactName = 'Facility Primary Contact Name cannot contain numbers, special characters, or exceed 100 characters';
  }

  if (formState.contactEmailAddress.trim() === '') {
    errors.contactEmailAddress = 'Facility Email is required'
  } else if (!isValidEmail(formState.contactEmailAddress.trim())) {
    errors.contactEmailAddress = 'Facility Email must be in a valid format';
  } else if (formState.contactEmailAddress.trim().length > 512) {
    errors.contactEmailAddress = 'Facility Email cannot exceed 512 characters'
  }

  if (formState.contactPhoneNumber.trim() === '') {
    errors.contactPhoneNumber = 'Facility Phone Number is required'
  } else if (!isValidUSOrCanadianPhoneNumber(formState.contactPhoneNumber) && !isValidMexicanPhoneNumber(formState.contactPhoneNumber)) {
    errors.contactPhoneNumber = 'Must enter a valid US, Canadian, or Mexican phone number in +1/+52 (XXX) XXX-XXXX format'
  }

  if (formState.clubFacilityContactName.trim() === '') {
    errors.clubFacilityContactName = 'Pre-Comp Primary Contact Name for Facility is required';
  } else if (!isValidName(formState.clubFacilityContactName.trim())) {
    errors.clubFacilityContactName = 'Pre-Comp Primary Contact Name for Facility cannot contain numbers, special characters, or exceed 100 characters';
  }

  if (formState.clubFacilityContactEmailAddress.trim() === '') {
    errors.clubFacilityContactEmailAddress = 'Pre-Comp Primary Contact Email is required';
  } else if (!isValidEmail(formState.clubFacilityContactEmailAddress.trim())) {
    errors.clubFacilityContactEmailAddress = 'Pre-Comp Primary Contact Email must be in a valid format';
  } else if (formState.clubFacilityContactEmailAddress.trim().length > 512) {
    errors.clubFacilityContactEmailAddress = 'Pre-Comp Primary Contact Email cannot exceed 512 characters'
  }

  if (formState.clubFacilityContactPhoneNumber.trim() === '') {
    errors.clubFacilityContactPhoneNumber = 'Pre-Comp Primary Contact Phone Number is required';
  } else if (!isValidUSOrCanadianPhoneNumber(formState.clubFacilityContactPhoneNumber)) {
    errors.clubFacilityContactPhoneNumber = 'Must enter a valid US phone number in +1 (XXX) XXX-XXXX format';
  }

  return errors;
};

export default PreCompLocationFacilityContactFormValidation;